import { authApi } from '../../utils/api';

export const adminRuhsatlarPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Ruhsat Yönetimi</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addRuhsatBtn">+ Yeni Ruhsat</button>
                    </div>
                </div>

                <!-- Ruhsat Ekleme/Düzenleme Modal -->
                <div id="ruhsatModal" class="modal" style="display: none;">
                    <div class="modal-content modal-large">
                        <div class="modal-header">
                            <h2 id="ruhsatModalTitle">Yeni Ruhsat Ekle</h2>
                            <button class="modal-close" id="closeRuhsatModal">&times;</button>
                        </div>
                        <form id="ruhsatForm" class="modal-form" enctype="multipart/form-data">
                            <input type="hidden" id="ruhsatId">

                            <div class="form-group">
                                <label for="ruhsatUserId">Kullanıcı *</label>
                                <select id="ruhsatUserId" class="form-control" required>
                                    <option value="">Kullanıcı Seçin</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="ruhsatImage">Ruhsat Görseli</label>
                                <input type="file" id="ruhsatImage" class="form-control" accept="image/*">
                                <div id="imagePreview" class="image-preview"></div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="plaka">Plaka</label>
                                    <input type="text" id="plaka" class="form-control" placeholder="34 ABC 123">
                                </div>
                                <div class="form-group">
                                    <label for="ruhsatSahibi">Ruhsat Sahibi</label>
                                    <input type="text" id="ruhsatSahibi" class="form-control">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="marka">Marka</label>
                                    <input type="text" id="marka" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="model">Model</label>
                                    <input type="text" id="model" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="modelYili">Model Yılı</label>
                                    <input type="number" id="modelYili" class="form-control" min="1900" max="2030">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="sasiNo">Şasi No</label>
                                    <input type="text" id="sasiNo" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="motorNo">Motor No</label>
                                    <input type="text" id="motorNo" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="tcNo">TC No</label>
                                <input type="text" id="tcNo" class="form-control" maxlength="11">
                            </div>

                            <div id="ruhsatFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelRuhsatBtn">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="ruhsatlarList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
